import styled from "styled-components";
import { motion } from "motion/react";

export const ProjectListContainer = styled.div`
  max-width: 400px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px 8px;
`;

export const ProjectListIconContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  height: fit-content;
  cursor: pointer;
  width: 70px;
  text-decoration: none;
  color: ${(props) => props.theme.black};
`;

export const ProjectListIcon = styled.img`
  width: 40px;
  height: 40px;
`;

export const ProjectListIconName = styled.div`
  font-size: ${(props) => props.theme.fontNormal}px;
  width: 80%;
  text-align: center;
`;
